import { Repository } from '../../../core/context/repository';
import { type Zone } from './entity';

export class Zones extends Repository<Zone> {}
